<div class="tsne-job-container">
    <div class="button-container">
        <button (click)="displayForm()" type="button" class="rectangle-selection-button">
            <div class="chevrons">
                <ng-container *ngIf="formIsVisible; then chevronDown"></ng-container>
                <ng-container *ngIf="!formIsVisible; then chevronRight"></ng-container>
                <ng-template #chevronRight>
                    <img src="../../../../assets/icons/chevron-right.svg" alt="chevron up" />
                </ng-template>
                <ng-template #chevronDown>
                    <img src="../../../../assets/icons/chevron-down.svg" alt="chevron down" />
                </ng-template>
            </div>
            TSNE
        </button>
        <button class="wiki-btn" (click)="goToWiki()">?</button>
    </div>
    <form
        class="form-container job-selection-dialog-content"
        [formGroup]="tsneForm"
        *ngIf="formIsVisible"
    >
        <cds-form-group layout="horizontal">
            <div class="experiment-name-input">
                <cds-select class="dropdown" controlWidth="shrink">
                    <label>Experiment name</label>
                    <select
                        [formControlName]="SELECTED_EXPERIMENT_NAME_KEY"
                        (change)="setExperiment($any($event.target).value)"
                    >
                        <option
                            *ngFor="let experiment of experiments"
                            [value]="experiment.name"
                        >
                            {{ experiment.name }}
                        </option>
                    </select>
                </cds-select>
                <div class="number-input-row" *ngIf="createJobMode">
                    <input
                        class="number-input-no-arrow string-input-no-arrow"
                        type="text"
                        [formControlName]="NEW_EXPERIMENT_NAME_KEY"
                    />
                </div>
            </div>
            <div>
                <cds-checkbox-group layout="horizontal">
                    <label>Input feature</label>

                    <ng-container *ngFor="let item of layerTypes">
                        <cds-checkbox>
                            <label>
                                {{ item.name }}
                            </label>
                            <input
                                type="checkbox"
                                [formControlName]="item.formControl"
                                [attr.disabled]="item.disabled ? '' : null"
                            />
                        </cds-checkbox>
                    </ng-container>
                </cds-checkbox-group>
            </div>
            <div class="number-input-row">
                <label class="number-input-label">
                    Perplexity
                    <span class="min-text">(min 1)</span>
                </label>
                <input
                    class="number-input-no-arrow"
                    type="number"
                    step="any"
                    [min]="1"
                    [formControlName]="PERPLEXITY_FORM_KEY"
                />
            </div>
            <div class="number-input-row">
                <label class="number-input-label">
                    Number of iterations
                    <span class="min-text">(min 250)</span>
                </label>
                <input
                    class="number-input-no-arrow"
                    type="number"
                    step="any"
                    [min]="250"
                    [formControlName]="NUMBER_OF_ITERATIONS_FORM_KEY"
                />
            </div>
            <cds-select class="dropdown" controlWidth="shrink">
                <label>Normalization</label>
                <select [formControlName]="NORMALIZATION_FORM_KEY">
                    <option *ngFor="let normalization of ClusteringNormalizationValues">
                        {{ normalization }}
                    </option>
                </select>
            </cds-select>
        </cds-form-group>
        <div class="tsne-form-footer">
            <div class="actions submit-button" *ngIf="formIsVisible">
                <span class="start-job-tooltip-host" [attr.title]="startJobTooltip">
                    <cds-button
                        size="sm"
                        (click)="confirmParams()"
                        [disabled]="!paramsValid || jobIsRunning || !createJobMode"
                        >{{ jobIsRunning ? 'Job is running' : 'Start Job' }}</cds-button
                    >
                </span>
            </div>
        </div>
    </form>
</div>
